import React, { Component } from "react";
import './Music-List.css';
import MusicList from "./Music-List";
import axios from '../tokenInterceptor';

class Sandbox extends Component {
    constructor(props) {
        super(props);
        this.state={
        }
    }

    render() {
        return (
            <>
                <div className="right-section">
                    <div className="main-page">
                        <h3>No info available</h3>
                    </div>
                    
                </div>
            </>
        )
    }
}

export default Sandbox;
